var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image 55 (Traced)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91374 0.17865C8.77553 0.528168 8.02386 1.18006 7.51301 2.2608C7.20778 2.9064 7.18602 3.07952 7.18486 4.86961L7.18358 6.78693H6.09186H5L5.03559 8.57853L5.07106 10.3701L6.12591 10.4066L7.18077 10.4432L7.21418 15.6871L7.2476 20.9311L9.39213 20.9656L11.5367 21V15.7205V10.4409L13.0377 10.4056L14.5388 10.3701L14.624 9.86722C14.671 9.59062 14.7302 8.79855 14.7554 8.10705L14.8015 6.84979L13.1691 6.81459L11.5367 6.77939V5.52024C11.5367 4.35087 11.5591 4.23897 11.851 3.95244C12.1444 3.66415 12.2534 3.64378 13.5017 3.64378C14.6023 3.64378 14.8518 3.60871 14.9158 3.44488C15.0648 3.06356 15.0013 0.307142 14.8399 0.148602C14.6215 -0.0658867 10.631 -0.0414961 9.91374 0.17865Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a0f2ca220a6cc074ca14eb05d2fc97e8.svg";
export { ForwardRef as ReactComponent };